<template>
  <form id="create-goal-form" @submit.prevent="editGoal">
    <div>
      <div class="col-md-12 form-wrapper">
        <h2>Edit Goal for {{ formatMonth(month) }}</h2>
        <div class="form-group mt-3">
          <label for="goal">Goal</label>
          <input
            type="number"
            id="goal"
            v-model="goalValue"
            name="goal"
            class="form-control"
            placeholder="30"
            step="0.25"
          />
        </div>
      </div>

      <div class="row g-3">
        <div class="d-flex justify-content-end mt-4">
          <router-link class="btn btn-primary btn-lg mr-2" to="/home"
            >Cancel</router-link
          >
          <button class="btn btn-success btn-lg" type="submit">
            Edit Goal
          </button>
        </div>
      </div>

      <div class="alert alert-danger" role="alert" v-if="putError">
        Invalid backend request!
      </div>
    </div>
  </form>
</template>

<script>
import { formatMonth, server } from "@/utils/helper";
import axios from "axios";
import router from "@/router";
export default {
  data() {
    return {
      month: "",
      goal: [],
      goalValue: null,
      putError: false,
    };
  },
  async created() {
    this.month = this.$route.params.month;
    await this.fetchGoal();
    this.goalValue = this.goal.goalValue;
  },
  methods: {
    formatMonth,
    async fetchGoal() {
      const bearerToken = localStorage.getItem("jwt");
      await axios
        .get(`${server.baseUrl}/goals/${this.month}`, {
          headers: { Authorization: "Bearer " + bearerToken },
          redact: ["authorization"],
        })
        .then((data) => (this.goal = data.data));
    },
    async editGoal() {
      let goalData = {
        month: this.month,
        goalValue: this.goalValue,
        user: "",
      };
      await this._submitToServer(goalData);
    },
    async _submitToServer(data) {
      const bearerToken = localStorage.getItem("jwt");
      await axios
        .put(`${server.baseUrl}/goals/${this.goal._id}`, data, {
          headers: { Authorization: "Bearer " + bearerToken },
          redact: ["authorization"],
        })
        .then(router.push({ name: "month", params: { month: this.month } }))
        .catch((error) => {
          console.log(error.message);
          this.putError = true;
        });
    },
  },
};
</script>
